var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Visitors ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c("gg-select", {
                        attrs: {
                          label: "Select a Domain",
                          "item-text": "txt",
                          "return-object": "",
                          loading: _vm.loadingDomains,
                          items: _vm.domains
                        },
                        model: {
                          value: _vm.selectedDomain,
                          callback: function callback($$v) {
                            _vm.selectedDomain = $$v
                          },
                          expression: "selectedDomain"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        attrs: {
                          "hide-details": "",
                          label: "Search"
                        },
                        model: {
                          value: _vm.table.search,
                          callback: function callback($$v) {
                            _vm.$set(_vm.table, "search", $$v)
                          },
                          expression: "table.search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-data-table", {
                        attrs: {
                          loading: _vm.loadingVisitors,
                          headers: _vm.table.headers,
                          items: _vm.visitors,
                          search: _vm.table.search,
                          "footer-props": {
                            itemsPerPageOptions: _vm.pagination
                          },
                          "sort-by": "timestamp"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.date",
                            fn: function fn(_ref) {
                              var item = _ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formattedDate(item.date)) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }